import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279451b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center mt-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-1" }, "Translations:")
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "pallinoAlert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_form_field, _mergeProps(_ctx.$props, {
      modelValue: _ctx.modelValue.values[_ctx.selectedLanguage],
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.values[_ctx.selectedLanguage]) = $event)),
        _ctx.onUpdate
      ]
    }), null, 16, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("div", null, [
          (_ctx.remaining)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.remaining) + " empty", 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (item, i) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["btn btn-small btn-link position-relative me-1", { active: _ctx.selectedLanguage == item }]),
          key: i,
          onClick: ($event: any) => (_ctx.selectedLanguage = item)
        }, [
          _createTextVNode(_toDisplayString(item) + " ", 1),
          (_ctx.empties[item])
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}